import { FC } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { SectionLayout } from 'components'

import RecordingCard from './RecordingCard'
import styles from './KeynoteRecording.module.scss'

const recordingsList = [
  {
    id: uuidv4(),
    name: '',
    videoUrl: 'https://www.youtube.com/embed/FNEBGGo6-5k?si=BxTH-td4SEoF-uRZ',
  },
  {
    id: uuidv4(),
    name: '',
    videoUrl: 'https://www.youtube.com/embed/hnujfk09Oek?si=AEqw-q-2rCAC1R_Y',
  },
  {
    id: uuidv4(),
    videoUrl: 'https://www.youtube.com/embed/1m3G2QbnKdI?si=pvrQ7bZ_4N9YshwW',
    name: '',
  },
  {
    id: uuidv4(),
    name: '',
    videoUrl: 'https://www.youtube.com/embed/NpiolMGht9o?si=1KlTIA1sIKvVPbt1',
  },
]

type KeynoteRecordingProps = {
  isEdition?: boolean
  addToRefs?: (el: HTMLDivElement) => void
}

const KeynoteRecording: FC<KeynoteRecordingProps> = ({ addToRefs }) => {
  const renderRecordingsList = recordingsList.map(item => <RecordingCard key={item.id} item={item} />)

  return (
    <SectionLayout addToRefs={addToRefs} id='RECORDING' className={styles.wrapper}>
      <div className='container'>
        <h2 className={styles.wrapper__title}>Keynote Recordings</h2>
        <div className={styles.content}>{renderRecordingsList}</div>
      </div>
    </SectionLayout>
  )
}

export default KeynoteRecording
